import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, setToken, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { applySession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    // clear the fragment so the token isn't left in the URL
    window.history.replaceState(null, "", window.location.pathname);

    if (!sessionId) {
      navigate("/admin/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId }, withCredentials: true });
        setToken(data.session_token);
        applySession(data.session_token, data.user);
        toast.success("Berhasil masuk dengan Google");
        navigate("/admin", { replace: true });
      } catch (err) {
        toast.error("Gagal masuk", { description: formatApiError(err.response?.data?.detail, "Akun Google tidak diizinkan.") });
        navigate("/admin/login", { replace: true });
      }
    })();
  }, [applySession, navigate]);

  return (
    <div className="grid min-h-screen place-items-center bg-navy text-sand-50" data-testid="auth-callback">
      <div className="text-center">
        <span className="mx-auto block h-10 w-10 animate-spin rounded-full border-2 border-gold/30 border-t-gold" />
        <p className="mt-6 font-grotesk text-sm uppercase tracking-[0.3em] text-gold">Memverifikasi…</p>
      </div>
    </div>
  );
}
